export class Paths {
    constructor(locale) {
        this.locale = locale;
        this.base = `/#/${this.locale}`;
        this.home = this.base;
        this.noOp = this.base;
        this.settings = `${this.base}/settings`;
        this.sessionLog = `${this.base}/session-log`;
    }
    conversation(conversation) {
        return `${this.base}/conversations/${conversation.id}`;
    }
    localeChange(locale) {
        return `/#/${locale}`;
    }
}
